import { Grid } from "@mui/material";
import AcxVirtualizedSelectMulti from "components/UI/Select/AcxVirtualizedSelectMulti";
import { observer } from "mobx-react";
import React from "react";
import type ChartCardStore from "../ChartCardStore";
import { Module } from "components/Admin/Organizations/types/Module.type";

type ModulesControlProps = {
    store: ChartCardStore;
    showComparePrevCheckbox: boolean;
    modules: Array<Module>;
};

const ModulesControl = observer(
    ({ store, showComparePrevCheckbox, modules }: ModulesControlProps) => {
        const optionsLoading = store.optionsStore.orgModulesLoading;

        return (
            <Grid item xs={showComparePrevCheckbox ? 6 : 8}>
                <AcxVirtualizedSelectMulti
                    options={modules}
                    id={`modules-select-${store.id}`}
                    onApply={(ids) => {
                        store.setSelectedId("modules", ids);
                        store.handleSelectionChange();
                    }}
                    itemName="Module"
                    defaultSelectedIds={
                        store.selectedIds["modules"] as string[] | undefined
                    }
                    labelField="displayName"
                    idField="id"
                    maxSelectionCount={store.getMaxSelection()}
                    isLoading={optionsLoading}
                    enableCompactLayout
                    disabled={store.isReadOnly}
                    disabledAppearance="readOnly"
                />
            </Grid>
        );
    },
);

export default ModulesControl;
